export const pagePaths = {
  home: '/',
  menu: '/catering',
  spitbraai: '/spit-braai',
  decor: '/decor',
  sound: '/sound',
  teambuilding: '/team-building',
  venuesupport: '/venue-support',
  estimate: '/estimate',
  contact: '/contact',
  blog: '/blog',
};

export const blogPostPath = (slug) => `/blog/${slug}`;
